/**
 * Cloudflare Turnstile — protection anti-bot des formulaires publics.
 * La sitekey est publique (elle est visible dans le HTML de toute façon) ; le secret
 * reste côté proxy-server (TURNSTILE_SECRET_KEY) qui fait l'appel siteverify.
 * Widget « FocusPips newsletter » (mode managed, hostnames focuspips.com + localhost) ;
 * VITE_TURNSTILE_SITE_KEY permet de la surcharger sans toucher au code.
 */
export const TURNSTILE_SITE_KEY: string = import.meta.env.VITE_TURNSTILE_SITE_KEY || '0x4AAAAAAE68UEBgvSrs-kJR';

/** Valeur `data-action` vérifiée côté serveur (doit rester identique à NEWSLETTER_TURNSTILE_ACTION). */
export const TURNSTILE_ACTION_NEWSLETTER = 'newsletter_join';
